import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Is this window the Microsoft sign-in popup, holding an auth response?
 *
 * Microsoft sends the popup back to this origin (the registered redirect URI)
 * with the response in the URL fragment. Requiring an opener as well as an
 * auth-shaped fragment keeps ordinary target=_blank windows rendering normally.
 */
const isMicrosoftAuthPopup =
  typeof window !== 'undefined' &&
  !!window.opener &&
  window.opener !== window &&
  /[#&?](code|error|state|id_token)=/.test(window.location.hash);

if (isMicrosoftAuthPopup) {
  /*
   * Hand the response to the window that opened us, and nothing else.
   *
   * msal-browser v5 does not poll the popup's URL the way earlier versions did:
   * `acquireTokenPopup` waits on a BroadcastChannel message, and the only thing
   * that publishes it is `broadcastResponseToMainFrame` from the library's
   * `redirect-bridge` entry point. The main bundle never calls it - the page
   * sitting on the redirect URI has to. Nothing did, so the opener waited
   * forever while the popup sat there.
   *
   * The bridge reads the response, publishes it, and closes this window. The
   * app itself must NOT render here: with no token yet its router would replace
   * the URL with /login (App.tsx PrivateRoute) and destroy the fragment before
   * the bridge could read it.
   */
  import('@azure/msal-browser/redirect-bridge')
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch((error) => {
      // The opener still has its own timeout, so surface this rather than
      // leaving a blank popup with no explanation.
      console.error('[MicrosoftAuth] Failed to relay the sign-in response:', error);
    });
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
